import { inject } from '@angular/core';
import { CURRENT_TRIP } from '../services';

/**
 * Returns the id of the current trip.
 * @returns {Signal<string>}
 * @requires TripService - Must be run in provider context.
 */
export function getTripId(): string | undefined {
  return inject(CURRENT_TRIP, { optional: true })?.tripId();
}
